import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DxContextMenuComponent } from 'devextreme-angular';
import { AbcContextMenu, SubmenuDirection } from '../../../base/src/abcContextMenu/abcContextMenu';

@Component({
  selector: '',
  template: ` <dx-context-menu
    #dxContextMenu
    [id]="id"
    [dataSource]="source"
    [width]="width"
    [height]="height"
    [closeOnOutsideClick]="closeOnOutsideClick"
    [submenuDirection]="submenuDirection"
    [disabled]="disabled"
    [rtlEnabled]="rtlEnabled"
    [class]="class"
    (onItemClick)="itemClick($event)"
    [target]="target"
  >
  </dx-context-menu>`,
})
export class DevExContextMenuComponent {
  @ViewChild('dxContextMenu', { static: true }) dxContextMenu: DxContextMenuComponent;
  @Input() source: AbcContextMenu[];
  @Input() id: string;
  @Input() class: string;
  @Input() target: string;
  @Input() closeOnOutsideClick: boolean;
  @Input() width: string | number;
  @Input() height: string | number;
  @Input() submenuDirection: SubmenuDirection;
  @Input() disabled: boolean;
  @Input() rtlEnabled: boolean;
  @Output() onItemClick = new EventEmitter();
  @Output() onChange: EventEmitter<any> = new EventEmitter();

  public itemClick(e) {
    this.onItemClick.emit(e);
  }

  public refrech() {
    if (this.dxContextMenu && this.dxContextMenu.instance) {
      this.dxContextMenu.instance._refresh();
    }
  }

  public hide() {
    this.dxContextMenu?.instance?.hide();
  }
}
